module.exports = "<p>widget-dashboard works!\n\n    <button (click)=\"GoToDashBoard()\">\n    Click TO Dashboard\n    </button>\n    \n    </p>\n    "